module.exports = __webpack_public_path__ + "static/media/PEXA-help-center.82ce6320.svg";